const hasSlider = document.querySelector('.js-logotypes-slider__slider .swiper');

if (hasSlider) {
	Promise.all([
		import('swiper'),
		import(
			/* webpackExports: ["Navigation", "Pagination"] */
			'swiper/modules'
		),
	])
		.then(([{ default: Swiper }, { Navigation, Pagination }]) => {
			const swiper = new Swiper('.js-logotypes-slider__slider .swiper', {
				slidesPerView: 'auto',
				spaceBetween: 16,
				watchSlidesProgress: true,
				pagination: {
					el: '.js-logotypes-slider__slider .swiper-pagination',
				},
				navigation: {
					prevEl: '.js-logotypes-slider__slider-arrow-left',
					nextEl: '.js-logotypes-slider__slider-arrow-right',
				},
				modules: [Navigation, Pagination],
			});
		})
		.catch((err) => console.error(err));
}
